import * as types from '../../constants/ActionTypes';

export const setApplicationId = id => ({
    type: types.SET_APPLICATION_ID,
    id,
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/applicationIdActions.js